import api from './api';

export const studentService = {
    createStudent: async (studentData) => {
        return await api.post('/students', studentData);
    },

    getStudents: async () => {
        return await api.get('/students');
    },

    getStudentById: async (id) => {
        return await api.get(`/students/${id}`);
    },

    getStudentDashboard: async (id) => {
        return await api.get(`/students/${id}/dashboard`);
    },

    getCurrentLevel: async (id) => {
        return await api.get(`/students/${id}/current-level`);
    },

    updateStudent: async (id, data) => {
        return await api.put(`/students/${id}`, data);
    },

    deleteStudent: async (id) => {
        return await api.delete(`/students/${id}`);
    }
};